import React from "react";
import Typography from "@material-ui/core/Typography";
// import { languages } from "../../constants/languages";
import Paper from "@material-ui/core/Paper";
import { withTheme } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

class LivePage extends React.Component {
  render() {
    return (
      <Paper
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            background: this.props.theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            height: 30,
            paddingLeft: 10,
            borderRadius: "4px 4px 0px 0px",
          }}
        >
          <Typography
            variant="body2"
            style={{
              color: "white",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {this.props.pageTitle}
          </Typography>

          <div style={{ flex: "1 1 1%" }} />

          {/* <Typography variant="body2" style={{ color: "white" }}>
            {languages.present.active}
          </Typography> */}
          <Checkbox
            checked={this.props.checked}
            onClick={(event) => {
              this.props.handleShowPageCheck(event, this.props.pageId);
            }}
            style={{ height: 35, width: 35, color: "white" }}
          />
          {/* <EditDiaContainer
            tournament={this.props.tournament}
            dia={this.props.dia}
            dias={this.props.dias}
            days={this.props.days}
            daysByKey={this.props.daysByKey}
          /> */}
        </div>
        {this.props.image}
        {this.props.button && this.props.button}
      </Paper>
    );
  }
}

export default withTheme(LivePage);
